import './InputText.scss';
import { forwardRef } from "react";
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';

const PrimeInputText = forwardRef((props, ref) => {
  const { className, leftIcon, rightIcon,...restProps } = props

  const textField = <InputText ref={ref} className={classNames(`PrimeInputText`, className)} {...restProps} />

  if (leftIcon) {
    return (
      <div className={`LeftIconContainer relative`}>
        <span className='IconContainer absolute flex flex-column justify-content-center'>
          {leftIcon}
        </span>
        {textField}
      </div>
    )
  }
  // if (rightIcon) {
  //   return (
  //     <span className={`RightIconContainer ${insetTypeClassName} ${rightIconContainerClass} ${isActiveClassName} p-input-icon-right`}>
  //       {textField}
  //       {rightIcon}
  //     </span>
  //   )
  // }

  return textField
})

PrimeInputText.defaultProps = {
  leftIcon: null,
  rightIcon: null,
}

export default PrimeInputText